import React from 'react';
import { BarChart2, MaskDataCard } from '../../components';
import { Grid, Image } from 'semantic-ui-react'
const RealTimeMask  = () => {
    console.log("Hello Hi")
    return (
        <div>
            <MaskDataCard/>
        </div>
    )
}

export default RealTimeMask;